//This file contains json lists for the following drop downs
// 1] feedback types
// 2] feedback linkage dropdown
//


export const feedbacktype = [{ value: "Bug", label: "Bug" },
{ value: "Feature Request", label: "Feature Request" },
{ value: "Help Request", label: "Help Request" },
{ value: "Missing Data", label: "Missing Data" },
{ value: "Report Request", label: "Report Request" }];

export const linkedtype = [{ value: "Blocks", label: "Blocks" },
{ value: "Is Blocked By", label: "Is Blocked By" },
{ value: "Clones", label: "Clones" },
{ value: "Is Cloned By", label: "Is Cloned By" },
{ value: "Duplicates", label: "Duplicates" },
{ value: "Is Duplicated By", label: "Is Duplicated By" },
{ value: "Relates To", label: "Relates To" }];

export const prioritylevel = [{ value: "NOW", label: "NOW" },
{ value: "This Week", label: "This Week" },
{ value: "End of Month", label: "End of Month" },
{ value: "Thinking Time", label: "Thinking Time" },
{ value: "Collaboration Needed", label: "Collaboration Needed" }];




export const ReportDurations = [
    { value: 1, label: "1 Week", days: 7 },
    { value: 2, label: "2 Week", days: 14 },
    { value: 3, label: "4 Week", days: 28 },
    { value: 4, label: "6 Week", days: 42 },
    { value: 5, label: "3 Month", days: 92 },
    { value: 6, label: "6 Month", days: 183 },
    { value: 7, label: "1 Year", days: 365 },
    { value: 8, label: "All Time", days: 5000 }];